import React, {Component} from 'react';
import './about.css';
import ReactHtmlParser from 'react-html-parser';

class About extends Component {
    state = {
      pageData: this.props.pageData
    };
    render() {
        return <div className="about">
                {this.props.lang === "tr" && <div className="contentText">{ReactHtmlParser(this.state.pageData.content_tr)}</div>}
                {this.props.lang === "eng" && <div className="contentText">{ReactHtmlParser(this.state.pageData.content_eng)}</div>}
        </div>;
    }
}

export default About;